{
  "nl": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Gepubliceerd voor klanten en partners",
        "publishedCustomer": "Gepubliceerd voor klanten",
        "publishedPartners": "Gepubliceerd voor partners",
        "notPublished": "Niet gepubliceerd"
      }
    }
  }
}
